export const SIGNUP_SUCCESS="auth/SIGNUP_SUCCESS";
export const SIGNUP_FAILURE="auth/SIGNUP_FAILURE";
export const USER_DETAILS_SUCCESS="auth/USER_DETAILS_SUCCESS";
export const USER_DETAILS_FAILURE="auth/USER_DETAILS_FAILURE";
export const TEACHER_DETAILS_SUCCESS="auth/TEACHER_DETAILS_SUCCESS";
export const TEACHER_DETAILS_FAILURE="auth/TEACHER_DETAILS_FAILURE";
export const USERS_LIST_SUCCESS="auth/USERS_LIST_SUCCESS";
export const USERS_LIST_FAILURE="auth/USERS_LIST_FAILURE";